import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './shared/CTAButton';
import { CountdownTimer } from './shared/CountdownTimer';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-[#FFF8F0]" data-id="element-45">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#F5E6E0] opacity-50 -skew-x-12 translate-x-20 z-0" data-id="element-46" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#C9A96E] opacity-10 rounded-full blur-3xl z-0" data-id="element-47" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 pt-16 pb-20 md:pt-24 md:pb-32" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-4xl mx-auto" data-id="element-49">
          {/* Top Badge */}
          <div className="inline-block bg-[#9B2C5E]/10 border border-[#9B2C5E]/20 rounded-full px-4 py-1.5 mb-6" data-id="element-50">
            <span className="text-[#9B2C5E] font-semibold text-sm tracking-wide" data-id="element-51">
              45 clases · 100% online · acceso de por vida
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#1A1A2E] leading-tight mb-6" data-id="element-52">
            Terminación{' '}
            <span className="text-[#9B2C5E] italic font-serif" data-id="element-53">
              nivel estudio
            </span>
            : dominá preparación, estructura y torno
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-54">
            Para sets más prolijos y duraderos. Certificado avalado por la
            instructora.
          </p>

          {/* Price Anchor */}
          <div className="flex flex-col items-center justify-center mb-10" data-id="element-55">
            <div className="flex items-center gap-3 text-2xl md:text-3xl mb-2" data-id="element-56">
              <span className="text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-57">
                $99.99 USD
              </span>
              <span className="text-[#9B2C5E] font-bold" data-id="element-58">→ $29 USD</span>
            </div>
            <p className="text-sm text-[#C9A96E] font-bold uppercase tracking-widest" data-id="element-59">
              (Pago único) — precio promocional por tiempo limitado
            </p>
          </div>

          {/* CTA Area */}
          <div className="flex flex-col items-center gap-6" data-id="element-60">
            <CTAButton text="ACCEDER AHORA POR $29 USD" className="shadow-xl shadow-[#9B2C5E]/20 text-lg md:text-xl px-10 py-5" data-id="element-61" />

            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500" data-id="element-62">
              <span className="flex items-center" data-id="element-63">
                <ShieldCheck className="w-4 h-4 mr-1 text-[#C9A96E]" data-id="element-64" /> Pago
                seguro
              </span>
              <span className="flex items-center" data-id="element-65">
                <CheckCircle2 className="w-4 h-4 mr-1 text-[#C9A96E]" data-id="element-66" /> Acceso
                inmediato
              </span>
              <span className="flex items-center" data-id="element-67">
                <ShieldCheck className="w-4 h-4 mr-1 text-[#C9A96E]" data-id="element-68" /> Garantía
                7 días
              </span>
            </div>
          </div>

          {/* Timer */}
          <div className="mt-12 p-6 bg-white/50 backdrop-blur-sm rounded-2xl border border-[#C9A96E]/20 inline-block" data-id="element-69">
            <p className="text-center text-gray-500 text-sm mb-2" data-id="element-70">
              La oferta termina en:
            </p>
            <CountdownTimer data-id="element-71" />
          </div>
        </motion.div>
      </div>

      {/* Bottom decorative divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A96E] to-transparent opacity-50" data-id="element-72" />
    </section>;
}